// @flow

const ADD = 'ADD_TOAST_MESSAGE';
const REMOVE = 'REMOVE_TOAST_MESSAGE';

export {
  ADD as ADD_TOAST_MESSAGE,
  REMOVE as REMOVE_TOAST_MESSAGE,
};

function createMessage(id, text, type, dismissAfter) {
  return {
    id,
    text,
    type,
    dismissAfter,
  };
}

export function createModule(options = {}) {
  const {
    dismissInterval = 5000,
  } = options;

  let maxToastId = 0;

  const state = {
    messages: [],
  };

  const getters = {
    toastMessages: (st) => st.messages,
  };

  const actions = {
    [ADD]: function add(
      { commit },
      { text, type = 'info', dismissAfter = dismissInterval },
    ) {
      maxToastId += 1;
      const id = maxToastId;

      commit(ADD, createMessage(id, text, type, dismissAfter));
      setTimeout(() => commit(REMOVE, id), dismissAfter);
    },

    [REMOVE]: function remove({ commit }, id) {
      commit(REMOVE, id);
    },
  };

  const mutations = {
    [ADD]: function add(stateArg, data) {
      const st = stateArg;
      st.messages.push(data);
    },

    [REMOVE]: function remove(stateArg, id) {
      const st = stateArg;
      st.messages = st.messages.filter((m) => m.id !== id);
    },
  };

  return {
    state,
    getters,
    actions,
    mutations,
  };
}
